import React from "react";

import ReactToPrint from "react-to-print";
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

import FinanceiroService from '../../app/service/FinanceiroService'
import TipoDespesaReceita from '../../app/service/TipoDespesaReceita'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import './financeiro.css'
import imagemRelatorio from '../../pages/seguranca/img/ilaw-logo.png'

class ComponentToPrint extends React.Component {
  constructor(props) {
    super(props); 

    this.state = {
      nomeUsuario: '',
      dataImpressao: '',
      horaImpressao: '',
      filtro: null
    }
  }

  componentDidMount() {
    const usuarioLogado = this.context.usuarioAutenticado
    this.setState({nomeUsuario: usuarioLogado.nome});

    var dayName = new Array ("domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado")
    var monName = new Array ("janeiro", "fevereiro", "março", "abril", "Maio", "junho", "agosto", "outubro", "novembro", "dezembro")

    var data = new Date();

    var dataCompleta = dayName[data.getDay() ] + ", " + data.getDate () + " de " + monName [data.getMonth() ]   +  " de "  +     data.getFullYear ()

    var hora = data.getHours() + ":" + data.getMinutes() + ":" + data.getSeconds()

    this.setState({dataImpressao: dataCompleta});
    this.setState({horaImpressao: hora});
  }

  render() {
    return (
      <div>
        <br></br>
        <div style={{margin: '38px'}}>
            <div>
              <img src={imagemRelatorio} width="200" height="140"/>
            </div>
            <span className="relatorio">Relatório de Lançamentos Detalhado</span>
            <div>
              Impresso por: {this.state.nomeUsuario} &nbsp; 
              em: {this.state.dataImpressao}&nbsp;
              {this.state.horaImpressao}
            </div>
            <div>
              <span className="filtro">Filtros:&nbsp;{this.props.filtro}</span>
            </div>
            <div>
              Quantidade de Registros:&nbsp;{this.props.quantidade}
            </div>
            <hr></hr>
        </div>
        
        <div style={{margin: '46px'}}>
          <DataTable value={this.props.lancamentos}  alwaysShowPaginator responsiveLayout="scroll"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={4} emptyMessage=" "
                            paginatorRight selectionMode="multiple">
                    <Column style={{background: 'none'}} field="categoria" header="Categoria"></Column>
                    <Column style={{background: 'none'}} field="tipo.nome" header="Tipo"></Column>
                    <Column style={{background: 'none'}} field="vlLancamento" header="Valor"></Column>
                    <Column style={{background: 'none'}} field="dtVencimento" header="Dt. Vencto."></Column>
                    <Column style={{background: 'none'}} field="VlPago" header="Valor Pago"></Column>
                    <Column style={{background: 'none'}} field="dtPago" header="Dt. Pgto."></Column>
                    <Column style={{background: 'none'}} field="situacao" header="Situação"></Column>
          </DataTable>
        </div>

      </div>
    );
  }
}

ComponentToPrint.contextType = AuthContext;

class ImprimirRelatorio extends React.Component {

  constructor(props) {
    super(props)
    this.financeiroService = new FinanceiroService();
    this.tipoDespesaReceita = new TipoDespesaReceita();

    this.state = {
      lancamentosDetalhado: [],
      quantidade: 0,
      filtro: '',
    }
  }


  consultarRelatorioDetalhado = async (relatorio) => {
    await this.financeiroService.relatorioDetalhado(relatorio.empresa, relatorio.dataInicial, relatorio.dataFinal,
      relatorio.tipo, relatorio.categoria, relatorio.situacao, relatorio.codigo, relatorio.classificacao, relatorio.ordem)
        .then(response => {
          this.setState({lancamentosDetalhado: response.data});
          this.setState({quantidade: this.state.lancamentosDetalhado.length});
        }).catch(error => {
          this.setState(error.response.data);
          this.toast.show({severity:'error', summary: 'Relatórios', detail:`${this.state.detail}`, life: 4000});
        })
  }

  async componentDidMount() {
    const params = this.props.match.params;
    await this.consultarRelatorioDetalhado(params);

    //Montar a legenda do filtro
    var filtro = '';
    var dia = '';
    var mes = '';
    var ano = '';
    ano = params.dataInicial.substring(0,4);
    mes = params.dataInicial.substring(5,7);
    dia = params.dataInicial.substring(8,10);
    
    filtro = 'Datas[ ' + dia + '/' + mes + '/' + ano;
    
    ano = params.dataFinal.substring(0,4);
    mes = params.dataFinal.substring(5,7);
    dia = params.dataFinal.substring(8,10);
    
    filtro = filtro + ' a ' + dia + '/' + mes + '/' + ano + ' ]';

    if(params.categoria == 'T') {
      filtro = filtro + ', Despesas/Receitas[ Ambos ]';
    } else if(params.categoria == 'D') {
      filtro = filtro + ', Despesas/Receitas[ Despesas ]';
    } else {
      filtro = filtro + ', Despesas/Receitas[ Receitas ]';
    }
  
    if(params.tipo == '0') {
      filtro = filtro + ', Tipo[ Todos ]';
    } else {
      await this.tipoDespesaReceita.consultarTipoDespesaReceita(params.tipo)
        .then(response => {
          filtro = filtro + ', Tipo[ ' + response.data.nome + ' ]';
        }).catch(error =>  {
          this.toast.show({severity:'error', summary: 'Montagem de Filtro', detail:'Erro ao montar filtro de origem', life: 4000});
        })
    }

    if(params.situacao == 'T') {
      filtro = filtro + ', Situação[ Todas ]';
    } else if(params.situacao == 'P') {
      filtro = filtro + ', Situação[ Pagos ]';
    } else if(params.situacao == 'A') {
      filtro = filtro + ', Situação[ Pagos ]';
    } else {
      filtro = filtro + ', Situação[ Cancelados ]';
    }

    this.setState({filtro: filtro});
  }

  render() {
    return (
      <div className="content-wrapper">
        <section className="content-header">
          <div className="row">
            <div className="col-md-10">
              <div className="formGroup">
                <ReactToPrint
                  trigger={() => <a className="cursor" >Imprimir</a>}
                  content={() => this.componentRef}>
                </ReactToPrint>
                <ComponentToPrint lancamentos={this.state.lancamentosDetalhado} 
                                  quantidade={this.state.quantidade} 
                                  filtro={this.state.filtro}
                                  ref={el => (this.componentRef = el)} />
              </div>
            </div>
          </div> 
        </section>
      </div>
    );
  }
}

ImprimirRelatorio.contextType = AuthContext;
export default ImprimirRelatorio;
